import { css, Theme } from '@emotion/react'
import { helpers, fonts, typography, mq } from '@/styles'

export const styles = (theme: Theme) => ({
  button: {
    main: css`
      ${helpers.resetDefaults};

      display: flex;
      align-items: center;

      font-family: ${fonts.primary};
      font-size: ${typography.h6};
      font-weight: bold;
      white-space: nowrap;

      border-radius: 20px;
      padding: 14px 32px;

      height: 56px;
      width: 100%;
      overflow: hidden;

      transition: color 0.2s, background-color 0.2s;

      min-width: 0;

      ${mq.tablet(css`
        height: 52px;
      `)}

      ${mq.mobile(css`
        padding: 8px 26px;
        height: 46px;
      `)}
    `,
    primary: css`
      cursor: pointer;

      color: ${theme.colors.primary.normal};
      background-color: ${theme.colors.accent.normal};

      &:hover {
        background-color: ${theme.colors.accent.normalHover};
      }
    `,
    secondary: css`
      cursor: pointer;

      color: ${theme.colors.secondary.normal};
      background-color: ${theme.colors.primary.normal};

      &:hover {
        background-color: ${theme.colors.primary.normalHover};
      }
    `,
    disabled: css`
      cursor: not-allowed;

      color: ${theme.colors.secondary.darker};
      background-color: ${theme.colors.secondary.dark};

      &:hover {
        background-color: ${theme.colors.secondary.dark};
      }
    `,

    content: {
      main: css`
        display: flex;
        justify-content: center;

        width: 100%;
        min-width: 0;
      `,
      children: css`
        ${helpers.textOverflowEllipsis};
      `,
    },
  },
})
